module.exports = __webpack_public_path__ + "8bfb64602a9cc445b6539999e45d3cf8.png";